import { breakpoints } from '@spritz-finance/ui'
import styled from 'styled-components'

export const UserInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 500px;
    margin: 0 auto;
    ${breakpoints.xsmall} {
        width: 100%;
    }

    form {
        width: 100%;
    }
`

export const EditButtonContainer = styled.div`
    display: flex;
    justify-content: right;
    margin: 17.5px 0;
    margin-left: auto;
`

export const EditButton = styled.span`
    text-decoration: underline;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    &:hover {
        cursor: pointer;
    }
`

export const FormContainer = styled.div``
